import { normalizeAppointmentTime } from './appointmentTime';

const parseTime = (statement) => {
  const match = statement.match(/\b(?:at\s+)?(\d{1,2})(?:[:.]([0-5]\d))?\s*([ap])\.?m\.?\b/i);
  return match ? normalizeAppointmentTime(`${match[1]}:${match[2] || '00'} ${match[3]}M`) : '';
};

const parseProvider = (statement) => {
  const match = statement.match(/\b(dr\.?\s+[a-z][a-z.'-]*(?:\s+[a-z][a-z.'-]*){0,2})(?=(?:['’]s)?\s+(?:appointment|appt\.?|visit)\b)/i);
  return match ? match[1].replace(/['’]s$/i, '').replace(/[.'’]+$/g, '').replace(/^dr\s/i, 'Dr. ') : '';
};

const WEEKDAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

const getProfileDay = (now, timeZone) => {
  try {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone, year: 'numeric', month: '2-digit', day: '2-digit',
    }).formatToParts(now).reduce((result, part) => ({ ...result, [part.type]: part.value }), {});
    return new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day)));
  } catch {
    return null;
  }
};

const formatDay = (date) => date?.toISOString().slice(0, 10) || '';

const parseRelativeDate = (statement, now, timeZone) => {
  const profileDay = getProfileDay(now, timeZone);
  if (!profileDay) return '';
  if (/\btomorrow\b/i.test(statement)) {
    profileDay.setUTCDate(profileDay.getUTCDate() + 1);
    return formatDay(profileDay);
  }
  const weekdayMatch = statement.match(/\bnext\s+(sunday|monday|tuesday|wednesday|thursday|friday|saturday)\b/i);
  if (!weekdayMatch) return '';
  const targetDay = WEEKDAYS.indexOf(weekdayMatch[1].toLowerCase());
  const daysAhead = ((targetDay - profileDay.getUTCDay() + 6) % 7) + 1;
  profileDay.setUTCDate(profileDay.getUTCDate() + daysAhead);
  return formatDay(profileDay);
};

export const parseAppointmentStatement = (statement = '', { now = new Date(), timeZone = '' } = {}) => {
  const normalized = String(statement || '').trim();
  if (!normalized) return { title: '', provider: '', date: '', time: '', clarification: '' };

  const hasDoctor = /\b(?:doctor|dr\.?)\b/i.test(normalized);
  const hasUnclearWeek = /\bnext week\b/i.test(normalized);
  return {
    title: hasDoctor ? 'Doctor appointment' : 'Appointment',
    provider: parseProvider(normalized),
    date: hasUnclearWeek ? '' : parseRelativeDate(normalized, now, timeZone),
    time: parseTime(normalized),
    clarification: hasUnclearWeek ? 'Choose the exact date for “next week.”' : '',
  };
};
